/* eslint-disable */
export default header => {
    const btn_navs = header.querySelectorAll(".btn-nav");
    const btn_search = header.querySelector(".btn-search");
    const form = header.querySelector("form");
    const nav = header.querySelector("nav");

    let onceTrig = false;
    let isTrig = false
    let timeout;
    let isOpen = false;
    let isSearch = false;
    let disabled = false;

   if(window.scrollY > 30 ? true : false) {
    header.classList.add("nofx");
    setTimeout(() => header.classList.remove("nofx"), 1)
   }

    const onscroll = () => {
        isTrig = window.scrollY > 30 ? true : false;
        if (isTrig != onceTrig) {
            header.classList[isTrig ? "add" : "remove"]("trig");
            if (isTrig) {
                document.documentElement.classList.add('trig');
            } else {
                document.documentElement.classList.remove('trig');
            }
        }
        onceTrig = isTrig;
    }

    window.addEventListener("scroll", onscroll)

    onscroll();

    const open = () => {
        btn_navs.forEach(btn_nav => {
            btn_nav.classList.toggle("active");
        })
    }

    btn_navs.forEach(btn_nav =>
        btn_nav.onclick = () => {
            if (disabled) return;
            disabled = true;

            setTimeout(() => {
                disabled = false;
            }, 1000);

            open();

            if (btn_nav.classList.contains("active")) {
                isOpen = true;
                header.classList.add("open");

            } else {
                isOpen = false;
                header.classList.add("close");

                setTimeout(() => {
                    header.classList.remove("open");
                    header.classList.remove("close");

                }, 600);
            }
        }
    )

    if (btn_search) {
        btn_search.onclick = () => {
            form.classList.toggle("open");

            // isOpen = true;
            if (form.classList.contains("open")) {
                header.classList.add("overlay")
                isSearch = true;
            } else {
                isSearch = false;
                header.classList.remove("overlay")
            }

        }
    }


    const close = () => {
        isOpen = false;
        isSearch = false;
        header.classList.remove("hover");
        header.classList.remove("overlay")
        /* header.addEventListener("transitionend", (e) => {
             console.log(e.propertyName);
         })*/
    }

    const mouseenter = () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            header.classList.add("hover");
            header.classList.remove("overlay")
        }, 50)
    }

    const mouseleave = () => {
        clearTimeout(timeout);

        if (isSearch) {
            if (form.classList.contains("open")) {
                form.classList.remove("open")
                header.classList.remove("overlay")
                form.addEventListener("transitionend", () => close(), { once: true })
            } else {
                close();
            }
        } else {

            if (!isOpen) {
                header.classList.remove("hover");

            }
        }
    }

    nav.addEventListener("mouseenter", mouseenter, false)
    nav.addEventListener("mouseleave", mouseleave, false)

    // lang
    const btns = document.querySelectorAll(".lang-selector button");

    btns.forEach(btn => btn.onclick = () => btn.classList.toggle("open"))



    // link chinois anchor
    const links = header.querySelectorAll(".nav-panel .pages a");
    links.forEach(link => {
        link.addEventListener('click', () => {
            isOpen = false;
            header.classList.add("close");

            setTimeout(() => {
                header.classList.remove("open");
                header.classList.remove("close");
                btn_navs.forEach(btn_nav => btn_nav.classList.remove("active"))
            }, 10);
        })
    })
};

